import { IPromoDesktopSchema } from '../../repositories/newbuilding-promos/entities/promo/PromoDesktopSchema';
import { IPromoItem } from '../../types/promos/promos';

export const mapPromosPreview = (promo: IPromoDesktopSchema): IPromoItem => {
  return {
    labels: promo.labels,
    newbuildingIds: promo.newbuildingIds,
    promoName: promo.promoName,
    promoProps: promo.promoProps,
    providerLogo: promo.providerLogo,
    providerName: promo.providerName,
  };
};
